module.exports = __webpack_public_path__ + "img/ivc.02cb5805.png";